import { render, staticRenderFns } from "./DoctorCardChoice.vue?vue&type=template&id=03772d44"
import script from "./DoctorCardChoice.vue?vue&type=script&lang=js"
export * from "./DoctorCardChoice.vue?vue&type=script&lang=js"
import style0 from "./DoctorCardChoice.vue?vue&type=style&index=0&id=03772d44&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports